import React, { useEffect, useState } from 'react'
import "./About.css"
import { NavLink } from 'react-router-dom'
import Testimonials from './Testimonials'
function About() {
     const [image,setImage]=useState(false)
  
  useEffect(()=>{
      const interval=setInterval(()=>{setImage(prevState=>!prevState)},5000)
  
      return ()=>{clearInterval(interval)}
     },[])
  return (
    <>
      <section class="about-section">
    <div class="about-image">
      <img src={image?"https://i.pinimg.com/originals/d7/52/d2/d752d2c8ef90eb41c249a3e0483d9eef.gif":"https://i.pinimg.com/originals/48/59/c2/4859c2ce288cd0003c26a92aa5974a8f.gif"} alt="Leather Craft"/>
    </div>
    <div class="about-content">
    <h2>About Us</h2>

<p>
  At Morara Homes Furniture, we’re not just making furniture — we’re creating lasting comfort.  
  With a passion for craftsmanship, design, and authenticity, we craft pieces that transform houses  
  into homes and bring people together in beautiful, functional spaces.  
</p>




      <NavLink to="/quote"><span className='btn'>Request a Quote</span></NavLink>
    </div>
  </section>
<Testimonials/>
    </>
  )
}

export default About
